function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DownDirectionArrow from "../icon-components/down-direction-arrow";
import Attention from "../icon-components/attention";
import UpDirectionArrow from "../icon-components/up-direction-arrow";

var CollapsableAlert =
/*#__PURE__*/
function (_Component) {
  _inherits(CollapsableAlert, _Component);

  function CollapsableAlert() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CollapsableAlert);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CollapsableAlert)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isCollapsed: true
    });

    return _this;
  }

  _createClass(CollapsableAlert, [{
    key: "_toggleCollapse",
    value: function _toggleCollapse() {
      var _this2 = this;

      var isCollapsed = this.state.isCollapsed;
      return function () {
        _this2.setState({
          isCollapsed: !isCollapsed
        });
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          titleText = _this$props.titleText,
          subtitleText = _this$props.subtitleText,
          collapsedText = _this$props.collapsedText,
          expandedText = _this$props.expandedText,
          children = _this$props.children;
      var isCollapsed = this.state.isCollapsed;
      var attentionStyle = style === 'danger' ? 'error' : 'incomplete';
      return React.createElement("div", {
        className: "CollapsableAlert CollapsableAlert-".concat(style)
      }, React.createElement("div", {
        className: "CollapsableAlert-top-banner"
      }, React.createElement(Attention, {
        status: attentionStyle
      }), React.createElement("div", {
        className: "CollapsableAlert-titles"
      }, React.createElement("h3", {
        className: "CollapsableAlert-".concat(style, "-title")
      }, titleText), React.createElement("p", {
        className: "CollapsableAlert-subtitle"
      }, subtitleText)), React.createElement("button", {
        type: "submit",
        className: "CollapsableAlert-button",
        onClick: this._toggleCollapse()
      }, isCollapsed ? collapsedText : expandedText, isCollapsed ? React.createElement(DownDirectionArrow, null) : React.createElement(UpDirectionArrow, null))), !isCollapsed && React.createElement("div", {
        className: "CollapsableAlert-expanded-contents"
      }, children));
    }
  }]);

  return CollapsableAlert;
}(Component);

_defineProperty(CollapsableAlert, "defaultProps", {
  style: 'default',
  collapsedText: 'SEE REASONS',
  expandedText: 'HIDE REASONS'
});

_defineProperty(CollapsableAlert, "propTypes", {
  style: PropTypes.oneOf(['default', 'warning', 'danger']),
  titleText: PropTypes.string,
  subtitleText: PropTypes.string,
  collapsedText: PropTypes.string,
  expandedText: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
});

_defineProperty(CollapsableAlert, "displayName", 'CollapsableAlert');

export default CollapsableAlert;